// ---------------------------- //
//             Test             //
// ---------------------------- //

var $ = require('jquery');
var inherits = require('inherits');
var EventEmitter = require('events').EventEmitter;

function Test(obj, config) {

    this.test = obj;
    this.classes = window.SFL.Settings.Classes;

    // Default configuration
    this.config = $.extend({
        delay: 300
    }, config);

    // Elements
    this.slidesWrapper = this.test.find('.test-content-wrapper');
    this.slidesContainer = this.test.find('.test-content-slides-container');
    this.slides = this.test.find('.test-content-slide');
    this.headerText = this.test.find('.test-header-right-content');
    this.homeSlide = this.slides.filter('.is-home');
    this.questionSlides = this.slides.filter('.is-question');
    this.resultSlide = this.slides.filter('.is-result');
    this.navigationButtonsWrapper = this.test.find('.navigation-buttons');
    this.navigationButtons = this.test.find('.navigation-button');
    this.startTestButton = this.homeSlide.find('.button.is-start');
    this.endTestButton = this.resultSlide.find('.button.is-end');
    this.resultTexts = this.resultSlide.find('.test-result-text');
    this.progressBar = this.test.find('.navigation-bar-progress');
    this.progressBarCurrent = this.test.find('.navigation-bar-progress-current');
    this.backButton = this.test.find('.btn-previous-question');

    this.score = [];

    // Component initialization
    this.init();

}

inherits(Test, EventEmitter);

$.extend(Test.prototype, {

    // Component initialization
    init: function() {
        this.layout();
        this.bindEvents();
    },

    bindEvents: function() {
        this.startTestButton.on('click', $.proxy(function(e) {
            this.startTest(e.currentTarget);
        }, this));
        this.navigationButtons.on('click', $.proxy(function(e) {
            this.showNextSlide(e.currentTarget, true);
        }, this));
        this.backButton.on('click', $.proxy(function(e) {
            this.showPrevSlide(e.currentTarget);
        }, this));
        $(window).debounceResize($.proxy(function() {
            this.updateLayout();
        }, this));
    },

    layout: function() {
        this.slidesContainer.css('max-height', this.slides.filter('.is-home').outerHeight());
        this.slidesContainer.css('width', this.slides.length * 100 + '%');
        this.slides.css('width', 100 / this.slides.length + '%');
        this.progressBarCurrent.css('width', 100 / this.slides.filter('.is-question').length + '%');

        // Show the wrapper when the layout is completed
        var cssReady = window.setInterval($.proxy(function() {
            if (this.slidesContainer.attr('style') !== '' && this.slides.attr('style') !== '') {
                this.test.addClass(this.classes.active);
                clearInterval(cssReady);
            }
        }, this), 500);
    },

    updateLayout: function() {
        if (this.getCurrentSlideIndex() === 0) {
            this.slidesContainer.css('max-height', this.slides.filter('.is-home').outerHeight());
        } else if (this.getCurrentSlideIndex() === this.slides.length - 1) {
            this.slidesContainer.css('max-height', this.slides.filter('.is-result').outerHeight());
        } else {
            this.slidesContainer.css('max-height', this.getMaxSlideHeight());
        }
    },

    startTest: function(button) {
        this.showNextSlide(button, false);
        this.updateSlidesContainerHeight();
        this.navigationButtonsWrapper.addClass(this.classes.active);
        if (this.getLang() === 'fr') {
            dsftag_send('WT.ria_a', 'simulateur', 'WT.ria_c', this.getWT_ria_c(), 'WT.ria_ev', 'Play', 'WT.ria_f', '43');
        } else {
            dsftag_send('WT.ria_a', 'simulateur', 'WT.ria_c', this.getWT_ria_c(), 'WT.ria_ev', 'Play', 'WT.ria_f', '67');
        }
    },

    endTest: function() {
        this.showResult();
        this.slidesContainer.css('max-height', '400px');
        this.navigationButtonsWrapper.removeClass(this.classes.active);
    },

    showPrevSlide: function(button) {
        this.slidesContainer.css('left', (this.getCurrentSlideIndex() - 1) * -100 + '%');
        this.decrementCurrentSlideIndex();
        this.updateHeaderText();
        this.updateProgressBar();
        this.updateBackButton();
    },

    showNextSlide: function(button, updateScore) {
        this.slidesContainer.css('left', (this.getCurrentSlideIndex() + 1) * -100 + '%');
        this.incrementCurrentSlideIndex();
        this.updateHeaderText();
        this.updateProgressBar();
        this.updateBackButton();
        if (updateScore) {
            this.sendNextTag();
            this.updateScore(button);
        }
        if (this.getCurrentSlideIndex() + 1 === this.slides.length) this.endTest();
    },

    sendNextTag: function() {
        var index = this.getCurrentSlideIndex();
        var baseFR = 41;
        var baseEN = 65;
        var ria_f = this.getLang() === 'fr' ? baseFR + index : baseEN + index;
        dsftag_send('WT.ria_a', 'simulateur', 'WT.ria_c', this.getWT_ria_c(), 'WT.ria_ev', 'Suivant', 'WT.ria_f', ria_f);
    },

    showResult: function() {
        var ria_f;
        var resultIndex = this.getResultIndex();
        this.resultTexts.eq(resultIndex).addClass(this.classes.active);

        if (resultIndex === 0) {
            ria_f = this.getLang() === 'fr' ? 64 : 88;
        } else if (resultIndex === 1) {
            ria_f = this.getLang() === 'fr' ? 65 : 89;
        } else if (resultIndex === 2) {
            ria_f = this.getLang() === 'fr' ? 66 : 90;
        }

        dsftag_send('WT.ria_a', 'simulateur', 'WT.ria_c', this.getWT_ria_c(), 'WT.ria_ev', '100', 'WT.ria_f', ria_f);
    },

    updateScore: function(button) {
        var buttonScore = parseInt($(button).attr('data-points'));
        this.score[this.getCurrentSlideIndex() - 1] = buttonScore;
    },

    getFinalScore: function() {
        var score = 0;
        for (var i = 1, l = this.score.length; i < l; i++) {
            score += this.score[i];
        }
        return score;
    },

    getResultIndex: function() {
        var resultIndex;
        var range = this.slides.filter('.is-question').length * 2;
        var finalScore = this.getFinalScore();
        if (finalScore > (range / 3 / 2)) {
            resultIndex = 0;
        } else if (finalScore < (range / 3 / 2 * -1)) {
            resultIndex = 2;
        } else {
            resultIndex = 1;
        }
        return resultIndex;
    },

    updateSlidesContainerHeight: function() {
        this.slidesContainer.css('max-height', this.getMaxSlideHeight());
    },

    updateHeaderText: function() {
        if (!this.headerText.hasClass(this.classes.active)) this.headerText.addClass(this.classes.active);
        this.headerText.text(this.slides.eq(this.getCurrentSlideIndex()).attr('data-header-text'));
    },

    updateProgressBar: function() {
        var progress = 100 / this.slides.filter('.is-question').length * this.getCurrentSlideIndex();
        this.progressBar.css('width', progress + '%');
        this.progressBarCurrent.css('left', progress + '%');
    },

    updateBackButton: function() {
        if (this.slides.eq(this.getCurrentSlideIndex() - 1).hasClass('is-question') && !this.slides.eq(this.getCurrentSlideIndex()).hasClass('is-result')) {
            this.backButton.addClass(this.classes.active);
        } else {
            this.backButton.removeClass(this.classes.active);
        }
    },

    getMaxSlideHeight: function() {
        var height = 0;
        this.slides.filter('.is-question').each(function(index, el) {
            if ($(el).outerHeight() > height) {
                height = $(el).outerHeight();
            }
        });
        return height;
    },

    decrementCurrentSlideIndex: function() {
        this.slidesContainer.attr('data-current', this.getCurrentSlideIndex() - 1);
    },

    incrementCurrentSlideIndex: function() {
        this.slidesContainer.attr('data-current', this.getCurrentSlideIndex() + 1);
    },

    getCurrentSlideIndex: function() {
        return parseInt(this.slidesContainer.attr('data-current') ? this.slidesContainer.attr('data-current') : 0);
    },

    getLang: function() {
        return $('html').attr('lang');
    },

    getWT_ria_c: function() {
        return $('html').attr('lang') === 'fr' ? 116 : 117;
    }

});

// Export component
module.exports = function(obj, config) {
    // Loop through each object
    return obj.map(function(index, element) {
        return new Test($(element), config);
    });
};
